
























































import Vue from 'vue'
import {GatewayServiceProxy} from "@/service-proxies/app-v2/iot-console.service-proxies";
const gsp = new GatewayServiceProxy()
export const dic={
  "s1":"/images/gateway/s1.png",
  "s2":"/images/gateway/s2.png",
  "h2":"/images/gateway/h2.png",
  "mtpad_linux":"/images/gateway/pad.png",
  "mtpad_android":"/images/gateway/pad.png",
}

const columns = [
    {
    title: '网关',
    dataIndex: 'code',
    key: 'code',
    scopedSlots: { customRender: 'gateway' }
  },
]

export default Vue.extend({
  components: {

  },
  props:{
    // onChangeGateway:{
    //   type: Function
    // },
    // onSelectGateway:{
    //   type: Function
    // },
    // getTenantId:{
    //   type: Function
    // },
    selectParam:{
      type: Object,
      default () {
        return {
        }
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      currentPageIndex: 1,
      dataSource:[],
      gatewayList:[],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      selectGatewayIds : [],
      selectedRowKeys: [], //  网关列表勾选
      selectedRows: [], //  网关列表复选框勾选的数据项(所有字段的集合)
      currentGatewayCode: '', // 网关列表行选中key值
      currentGatewayId: '',
      firstGetList : true //第一次获取列表
    }
  },
  computed: {
    rowSelection() {
        return {
            onChange: (selectedRowKeys, selectedRows) => {
                this.selectedRows = selectedRows;
                this.selectedRowKeys = selectedRowKeys;
                this.onSelectGateway(selectedRows);
                if (this.selectedRows){
                  this.selectGatewayIds = this.selectedRows.map( item => item.id )
                }
            },
            selectedRowKeys: this.selectedRowKeys
        };
    },
  },
  mounted() {
  },
  created() {
    this.getGatewayList(true)
  },
  afterCreated(){

  },
  destroyed() {
  },
  methods: {
    customRow(record){
      return {
        on: {
          click: (event) => {
            this.selectedRowKeys=[record.code];
            this.selectedRows = [record];
            this.selectGatewayIds = [record.id]
            this.updateGateway(record);
            this.onSelectGateway([record]);
          },
        },
      };
    },
    getImageUrl(gatewayType){
      const url = dic[gatewayType];
      return url??"/images/gateway/s2.png";
    },
    updateGateway(record){
      this.$emit('onChangeGateway', record)
    },
    onSelectGateway(recordList){
      this.$emit('onSelectGateway', recordList)
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    // 获取网关列表
    async getGatewayList(reload?) {

      if (reload) {
        this.pagination.current = 1
      }
      this.gatewayList = []
      this.currentGatewayCode = ''
      this.currentGatewayId = ''
      let {  loginTenantId,filter, tenantId, isOnline, batchCode, workStationIdPattern } = this.selectParam
      let params: any = {
        current: this.pagination.current,
        filter: filter,
        size: this.pagination.pageSize,
        workStationIdPattern: workStationIdPattern,
        tenantId: loginTenantId === '000000' ? tenantId : loginTenantId,
        isOnline: String(isOnline) === '1' ? true : String(isOnline) === '0' ? false : undefined,
        batchCode,
        ascs: undefined,
        descs: undefined
      }
      this.loading = true
      try {
        let { items, totalCount } = await gsp.findGatewayList(params)
        this.pagination.total = totalCount
        this.gatewayList = items
        if (this.gatewayList && this.gatewayList.length) {
          this.gatewayList.map((item, index) => {
            if (item.associateWorkStations && item.associateWorkStations.length) {
              this.gatewayList[index].associateWorkStations =
                  this.gatewayList[index].associateWorkStations.join()
            }
          })
        }
        if (this.gatewayList.length) {
          this.currentGatewayCode = this.gatewayList[0].code
          this.currentGatewayId = this.gatewayList[0].id
          this.selectedRowKeys = [this.gatewayList[0].code]
          this.selectGatewayIds = [this.gatewayList[0].id]
          this.selectedRows = [this.gatewayList[0]]
        } else {
          this.currentGatewayCode = ''
          this.currentGatewayId = ''
          this.selectedRowKeys = []
          this.selectGatewayIds = []
          this.selectedRows = []
        }
      } catch (e) {
        console.log(e)
      }
      //初始化选中第一条数据
      if (this.firstGetList){
        if (this.gatewayList && this.gatewayList.length > 0){
          this.updateGateway(this.gatewayList[0]);
        }
      }
      this.loading = false
    },
    handleTableChange(current: number, pageSize: number) {
      const pager = {
        pageSize: pageSize,
        current: current
      }
      Object.assign(this.pagination, pager)
      this.getGatewayList()
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize
      this.getGatewayList(current)
    },
    pageCurrentchange(current: any){
      this.pagination.current = current
      this.getGatewayList()
    },
  },
  watch:{
    selectParam:{
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue){
        this.selectParam = newValue
      },
      deep: true
    },
    selectedRowKeys:{
      handler(){
        this.$emit("selectedRowKeysChange")
      }
    }
  }
})
